module.exports = __webpack_public_path__ + "static/media/view.817c7e33.svg";